import { type PointerEvent, type ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { HoverPreview } from '@/views/build/components/HoverPreview/HoverPreview';
import { type QuizType } from '@/views/build/components/type';
import { getQuizTypePreviewVideo } from '../consts/quizTypePreviewMedia';
import { QUIZ_TYPE_PREVIEWS } from '../consts/quizTypePreviews';
import { QuizTypePreviewCard } from './QuizTypePreviewCard';
type QuizTypeHoverPreviewProps = {
  type: QuizType;
  children: ReactNode;
  onPreviewOpen?: (type: QuizType) => void;
};

/** 브라우저 HTTP 캐시만 채운다 — 본문을 끝까지 읽어야 캐시에 다 들어가고, 실패하면 카드가 다시 받는다 */
const warmVideoCache = (url: string) => {
  void fetch(url).then(response => response.arrayBuffer()).catch(() => undefined);
};
export const QuizTypeHoverPreview = ({
  type,
  children,
  onPreviewOpen
}: QuizTypeHoverPreviewProps) => {
  const {
    t,
    i18n
  } = useTranslation(['build']);
  const handleTriggerPointerEnter = (event: PointerEvent) => {
    if (event.pointerType !== 'mouse') return;
    const video = getQuizTypePreviewVideo(type, i18n.language);
    if (video) warmVideoCache(video);
  };
  const handleOpenChange = (open: boolean) => {
    if (open) onPreviewOpen?.(type);
  };
  return <HoverPreview preview={<QuizTypePreviewCard type={type} />} description={t(QUIZ_TYPE_PREVIEWS[type].descriptionKey)} onOpenChange={handleOpenChange} onTriggerPointerEnter={handleTriggerPointerEnter} data-sentry-element="HoverPreview" data-sentry-component="QuizTypeHoverPreview" data-sentry-source-file="QuizTypeHoverPreview.tsx">
      {children}
    </HoverPreview>;
};